import { useContext, createContext } from 'react';
import { jsx } from 'react/jsx-runtime';

/**
 * similar to the createIndependentStore utility, this method creates a scoped
 * store that can be overriden inside the React render context using the
 * well-established <Provider store={...}> pattern from Redux itself
 *
 * contrary to the default Redux Provider, however, this pattern allows us to
 * provide scoped stores independently from one another (ie. providing a
 * fictional navigationStore.Provider will not override the state of a
 * fictional notifierStore.Provider)
 */
function createScopedStore(defaultStore) {
  const ProviderContext = /*#__PURE__*/createContext(defaultStore);
  function useSelector(selector, equalityFn) {
    const store = useContext(ProviderContext);
    return store.useSelector(selector, equalityFn);
  }
  function useDispatch() {
    return useContext(ProviderContext).dispatch;
  }
  function useStore() {
    return useContext(ProviderContext);
  }
  function Provider(props) {
    return /*#__PURE__*/jsx(ProviderContext.Provider, {
      value: props.store,
      children: props.children
    });
  }
  return {
    actions: defaultStore.actions,
    Provider,
    useSelector,
    useDispatch,
    useStore
  };
}

export { createScopedStore };
//# sourceMappingURL=create-scoped-store.js.map
